/**
 * Sample GPS coordinates by keeping every Nth point based on total count
 */
export const sampleGpsCoordinates = (coordinates, maxPoints = 200) => {
  if (!coordinates || coordinates.length === 0) return [];
  if (coordinates.length <= maxPoints) return coordinates;

  // Calculate sampling rate to get approximately maxPoints
  const sampleRate = Math.ceil(coordinates.length / maxPoints);

  // Always include first and last points
  const sampled = coordinates.filter(
    (_, index) =>
      index === 0 ||
      index === coordinates.length - 1 ||
      index % sampleRate === 0,
  );

  return sampled;
};
